<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ report.name }}</p>
    </header>

    <section class="modal-card-body">
      <form @submit.prevent="emailReport">
        <slot name="filters"></slot>

        <div class="columns">
          <div class="column is-two-thirds">
            <input type="email" v-model="email" class="input is-fullwidth is-large" required/>
          </div>

          <div class="column is-one-third">
            <button type="submit" class="button is-fullwidth is-large" v-submit="submitting">Email Report</button>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <a :href="downloadUrl" class="button is-fullwidth is-large" target="_blank">Download</a>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <a :href="viewUrl" class="button is-fullwidth is-large" target="_blank">View</a>
          </div>
        </div>
      </form>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
    </footer>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import HandlesForm from './../../mixins/HandlesForm'

export default {
  props: {
    report: {
      type: Object,
      default: {},
    },

    filters: {
      type: Object,
      default: {}
    }
  },

  mixins: [HandlesForm],

  data() {
    return {
      email: ''
    }
  },

  computed: {
    ...mapGetters(['currentUser', 'teams']),

    reportName() {
      return _.camelCase(this.report.name)
    },

    downloadUrl() {
      return `${this.report.url}/dl?` + _.param(this.filters)
    },

    viewUrl() {
      return `${this.report.url}?` + _.param(this.filters)
    }
  },

  mounted() {
    this.email = this.currentUser.email
  },

  methods: {
    emailReport() {
      this.wrapSubmit(() =>
          axios.post(`${this.report.url}/email`, _.merge({}, this.filters, {email: this.email}))
              .then(r => {
                this.successMessage('Report email has been queued')
                return r
              })
      )()
    }
  }
}
</script>